export default __webpack_public_path__ + "static/media/ball.4af89c7b.png";